import { useContext } from 'react';

import type { TruncationMode } from '@dynatrace/strato-components/typography';

import { HistogramTruncationModeContext } from '../contexts/HistogramTruncationMode.context.js';

export const useHistogramTruncationMode = (): TruncationMode =>
  useContext(HistogramTruncationModeContext);
